import { render, staticRenderFns } from "./Content_journal.vue?vue&type=template&id=1f75f431&scoped=true"
import script from "./Content_journal.vue?vue&type=script&lang=js"
export * from "./Content_journal.vue?vue&type=script&lang=js"
import style0 from "./Content_journal.vue?vue&type=style&index=0&id=1f75f431&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f75f431",
  null
  
)

export default component.exports